module.exports = "<div class=\"row\">\n  <div class=\"clol-xs-12\">\n    <div class=\"brightcove-component\" #player>\n\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/video-players/brightcove/brightcove.html
// module id = 4P6/
// module chunks = 3